// aifab - hooks/useSubmit.js
// Eliminates the [saving, setSaving] / [err, setErr] / try-catch-finally
// boilerplate that appears 27+ times across page and modal components.
//
// Usage:
//   const { run, saving, err, clearErr } = useSubmit();
//   await run(async () => {
//     await apiFetch('/some/endpoint', { method: 'POST', body: JSON.stringify(data) });
//     onDone();
//   });

import { useState, useCallback } from 'react';

export function useSubmit() {
  const [saving,  setSaving]  = useState(false);
  const [err,     setErr]     = useState(null);

  const run = useCallback(async (fn) => {
    setSaving(true);
    setErr(null);
    try {
      await fn();
    } catch (e) {
      setErr(e.message ?? String(e));
    } finally {
      setSaving(false);
    }
  }, []);

  const clearErr = useCallback(() => setErr(null), []);

  return { run, saving, err, clearErr };
}
